interface FormatRangeNumbersOptions {
  addSymbolDollar: boolean;
}

export const formatNumbers = (
  number1: number,
  options: FormatRangeNumbersOptions = { addSymbolDollar: false },
): string => {
  let num1 = (
    number1 >= 1000000 ? number1 / 1000000 : number1 >= 1000 ? number1 / 1000 : number1
  ).toFixed(1);
  num1 = num1.charAt(num1.length - 1) === '0' ? num1.slice(0, -2) : num1;

  const symbolCountMoneyNum1 = number1 >= 1000000 ? 'M' : number1 >= 1000 ? 'K' : '';

  return `${options.addSymbolDollar ? '$' : ''}${num1}${symbolCountMoneyNum1}`;
};

export const formatNumberWithCommas = (number?: number) => {
  if (!number) {
    return 0;
  }

  return number.toLocaleString();
};

export const goodFormatWithCurrency = (currency = 'USD') =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format;

export const goodFormatWithCurrencyLowPrecision =
  (currency = 'USD') =>
  (value: number) => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const formatted = formatter.format(value);

    if (value % 1 === 0) {
      return formatted.replace(/\.00$/, '');
    }

    return formatted;
  };
export const goodFormatUSDCurrency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
}).format;

export function goodFormatUSDCurrencyLowPrecision(value: number) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formatted = formatter.format(value);

  if (value % 1 === 0) {
    return formatted.replace(/\.00$/, '');
  }

  return formatted;
}

export function goodFormatNumber(value: number) {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formatted = formatter.format(value);

  if (value % 1 === 0) {
    return formatted.replace(/\.00$/, '');
  }

  return formatted;
}

export const goodFormatNumberCustom = (
  value: number,
  currency = '',
  minimumFractionDigits = 2,
  maximumFractionDigits = 4,
) => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  let formatted = formatter.format(value);

  if (value % 1 === 0) {
    formatted = formatted.replace(/\.00$/, '');
  }

  return `${formatted}${currency ? ' ' + currency : ''}`;
};

export function formatBytesSize(bytes: number, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  return parseFloat((bytes / Math.pow(1024, i)).toFixed(decimals)) + ' ' + sizes[i];
}

export function transliterate(text: string): string {
  const map: { [key: string]: string } = {
    а: 'a',
    б: 'b',
    в: 'v',
    г: 'g',
    д: 'd',
    е: 'e',
    ё: 'yo',
    ж: 'zh',
    з: 'z',
    и: 'i',
    й: 'y',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'n',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 's',
    т: 't',
    у: 'u',
    ф: 'f',
    х: 'kh',
    ц: 'ts',
    ч: 'ch',
    ш: 'sh',
    щ: 'shch',
    ъ: '',
    ы: 'y',
    ь: '',
    э: 'e',
    ю: 'yu',
    я: 'ya',
    і: 'i',
    ї: 'i',
    є: 'e',
    А: 'A',
    Б: 'B',
    В: 'V',
    Г: 'G',
    Д: 'D',
    Е: 'E',
    Ё: 'Yo',
    Ж: 'Zh',
    З: 'Z',
    И: 'I',
    Й: 'Y',
    К: 'K',
    Л: 'L',
    М: 'M',
    Н: 'N',
    О: 'O',
    П: 'P',
    Р: 'R',
    С: 'S',
    Т: 'T',
    У: 'U',
    Ф: 'F',
    Х: 'Kh',
    Ц: 'Ts',
    Ч: 'Ch',
    Ш: 'Sh',
    Щ: 'Shch',
    Ъ: '',
    Ы: 'Y',
    Ь: '',
    Э: 'E',
    Ю: 'Yu',
    Я: 'Ya',
    І: 'I',
    Ї: 'I',
    Є: 'E',
  };

  return text
    .split('')
    .map(char => map[char] ?? char)
    .join('');
}
